module.exports = __webpack_public_path__ + "img/der_01_data.9da4e458.svg";